import { IVehicleFactory } from '../../entities/vehicle/Vehicle'
import { parseIsoDateTime } from '../../utils/parse-date'

export interface IVehicleResponse {
    vehicle_id: string
    driver_name: string
    eta: {
        actual_eta: string // "2026-04-07T14:45:00+03:00"
        original_eta: string // "2026-04-07T14:30:00+03:00"
    }
    tracking: {
        geolocation: string | null
    }
    show_vehicle_notification: boolean
    arrival_in: number
    vendor_store_info: {
        lat: string
        lng: string
    }
}

export const transformVehicle = (
    vehicle: IVehicleResponse
): IVehicleFactory => {
    return {
        id: vehicle.vehicle_id,
        arrivalDuration: vehicle.arrival_in * 60,
        arrivesAt: parseIsoDateTime(vehicle.eta.actual_eta),
        originalArrivesAt: parseIsoDateTime(vehicle.eta.original_eta),
        driverName: vehicle.driver_name,

        geolocation: vehicle.tracking.geolocation
            ? {
                  lat: Number(vehicle.tracking.geolocation.split(' ')[0]),
                  lng: Number(vehicle.tracking.geolocation.split(' ')[1]),
              }
            : undefined,
        vendorGeolocation: {
            lat: Number(vehicle.vendor_store_info.lat),
            lng: Number(vehicle.vendor_store_info.lng),
        },
        shouldShow: vehicle.show_vehicle_notification,
    }
}
